import {Detalhamento, Solicitacao} from "@/models/sie-pedidos/solicitacao";
import {Lote} from "@/models/sie-pedidos/lote";
import {DadosFilterSolicitacao, PaginationTableSiePedidos} from "@/store/modules/sie-pedidos/states/table";
import {DadosFilterLotes, PaginationTableLotes} from "@/store/modules/sie-pedidos/states/tableLotes";

export default {
  setFormStep({commit}: any, value: number): void {
    commit('SET_FORM_STEP', value)
  },
  setTableContent({commit}: any, value: Solicitacao[]): void {
    commit('SET_TABLE_CONTENT', value)
  },
  setTableIsLoading({commit}: any, value: boolean): void {
    commit('SET_TABLE_LOADING', value)
  },
  setTableTotals({commit}: any, value: number): void {
    commit('SET_TABLE_TOTALS', value)
  },
  setTablePagination({commit}: any, value: PaginationTableSiePedidos): void {
    commit('SET_TABLE_PAGINATION', value)
  },
  clearTable({commit}: any): void {
    commit('CLEAR_TABLE')
  },
  setTableLotesContent({commit}: any, value: Lote[]): void {
    commit('SET_TABLE_LOTES_CONTENT', value)
  },
  setTableLotesIsLoading({commit}: any, value: boolean): void {
    commit('SET_TABLE_LOTES_LOADING', value)
  },
  setTableLotesTotals({commit}: any, value: number): void {
    commit('SET_TABLE_LOTES_TOTALS', value)
  },
  setTableLotesPagination({commit}: any, value: PaginationTableLotes): void {
    commit('SET_TABLE_LOTES_PAGINATION', value)
  },
  clearTableLotes({commit}: any): void {
    commit('CLEAR_TABLE_LOTES')
  },
  setTipoSolicitacao({commit}: any, value: String): void{
    commit('SET_TIPO_SOLICITACAO', value)
  },
  setDadosFormSolicitacao({commit}: any, value: any): void{
    commit('SET_DADOS_FORM_SOLICITACAO', value)
  },
  setDadosParaSolicitacao({commit}: any, value: any): void{
    commit('SET_DADOS_PARA_SOLICITACAO', value)
  },
  setEndereco({commit}: any, value: any): void{
    commit('SET_DADOS_FORM_ENDERECO', value)
  },
  setCPF({commit}: any, value: String): void{
    commit('SET_CPF', value)
  },
  setDadosFilterSolicitacao({commit}: any, value: object): void {
    commit('SET_DADOS_FILTER_SOLICITACAO', value)
  },
  clearDadosFormSolicitacao({commit}: any, value: any): void{
    commit('CLEAR_DADOS_FORM_SOLICITACAO', value)
  },
  setShowModalSolicitacaoAluno({commit}: any, value: object): void{
    commit('SET_SHOW_MODAL_SOLICITACAO_ALUNO', value)
  },
  setDetalhamentoSolicitacao({commit}: any, value: Detalhamento): void{
    commit('SET_DETALHAMENTO_SOLICITACAO', value)
  },
  setDadosFilterGrafica({commit}: any, value: DadosFilterLotes): void {
    commit('SET_DADOS_FILTER_GRAFICA', value)
  }
}
